import React, { useState, useEffect, useMemo } from 'react';
import LargePostCard from '../LargePostCard';
import CategoryPostCard from '../CategoryPostCard';
import {
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { PostsContext } from '../../contexts/PostsContext';
import { useContext } from 'react';
import { AdsContext } from '../../contexts/AdsContext';
import { getFeaturedPosts } from '../../utils/categoryUtils';
import LargePostCardDialog from '../LargePostCardDialog';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from '../../contexts/LocationContext';


const RetrievePost = ({
  selectedCategory,
  isFeatured,
  isGridView,
  // interleaveAds,
}) => {
  const { categoriesData, loading, selectedCountry } = useContext(PostsContext) || {};
  const posts = categoriesData[selectedCategory] || [];
  const featuredPosts = getFeaturedPosts(categoriesData);
  const [selectedCard, setSelectedCard] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const {
    userLocation,
  } = useLocation();
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg')); // Check if screen size is large or larger

  const displayedPost = posts

  const handleCardClick = (cardData) => {
    if (!cardData) {
      console.error('Card data is not available');
      return;
    }
    setSelectedCard(cardData); // cardData now contains category too so above code not needed
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCard(null);
  };

  return (
    <Box
      alignItems='center'
      mt={0}
      mb={4}
      mx='auto'
      gap={3}
      p={1}
      sx={{
        display: 'flex',
        justifyContent: isGridView
          ? isLgUp && parseInt(displayedPost.length) >= 4
            ? 'center'
            : 'center'
          : 'center',
        flexDirection: !isGridView && 'column',
        borderRadius: 2,
        maxWidth: '100%',
        flexWrap: 'wrap',
        overflowY: 'auto', // Enable vertical scrolling
        width: '100%',
        ml: 'auto',
        mr: 'auto',
        boxSizing: 'border-box',
      }}
    >
      {loading ? (
        <Box sx={{ width: '60%', ml: 'auto', mr: 'auto', mt: '25%' }}>
          <LinearProgress />
        </Box>
      ) : 
      displayedPost.length === 0 ? (
        <p>No posts available for this category.</p> // Show when there are no posts after loading
      ) : (
        <>
          {displayedPost.map((post, index) => (
            <React.Fragment key={post.id}>
              {isGridView ? (
                <Box sx={{ display: 'flex' }}>
                  <CategoryPostCard
                    key={post.id}
                    id={post.userId}
                    images={post.images || []}
                    title={post.title}
                    summary={post.description}
                    postID={post.id}
                    photoURL={post.userPhotoURL}
                    username={post.username}
                    name={post.name}
                    email={post.email}
                    location={post.location || null}
                    date={post.readableDate}
                    category={post.category}
                    onClick={() => handleCardClick(post)}
                    vertical='260px'
                    horizontal='300px'
                  />
                </Box>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <LargePostCard
                    key={post.id}
                    id={post.userId}
                    images={post.images || []}
                    title={post.title}
                    summary={post.description}
                    postID={post.id}
                    photoURL={post.userPhotoURL}
                    username={post.username}
                    name={post.name}
                    email={post.email}
                    location={post.location || null}
                    date={post.readableDate}
                    category={post.category}
                    onClick={() => handleCardClick(post)}
                    vertical='370px'
                    horizontal='700px'
                  />
                </Box>
              )}
            </React.Fragment>
          ))}
        </>
      )}
      {/* PopUp Dialog displaying LargePostCardDialog */}
      {selectedCard && (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth='lg'
          fullWidth
          PaperProps={{
            style: {
              maxHeight: 'calc(100vh - 15px)',
              overflowY: 'auto',
              height: '85vh',
              borderRadius: '24px',
            },
          }}
        >
          <DialogTitle sx={{ mb: 1, p: 2 }}>
            <IconButton
              aria-label='close'
              onClick={handleCloseDialog}
              sx={{
                position: 'absolute',
                right: { xs: 2, sm: 2, md: 4, lg: 8, xl: 8 },
                top: { xs: 1, sm: 1, md: 3, lg: 8, xl: 8 },
                color: (theme) => theme.palette.grey[500],
                '&:hover': {
                  backgroundColor: 'indianred',
                  color: 'white',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              mt: 0,
              mb: 0,
              p: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <LargePostCardDialog
              id={selectedCard.userId}
              postID={selectedCard.id}
              images={selectedCard.images}
              title={selectedCard.title}
              summary={selectedCard.description}
              link={selectedCard.link}
              ratings={selectedCard.ratings}
              postInfo={selectedCard} // Pass the whole object
              photoURL={selectedCard.userPhotoURL}
              username={selectedCard.username} //pass the username to LargePostCard
              name={selectedCard.name}
              email={selectedCard.email}
              location={selectedCard.location || null}
              date={selectedCard.readableDate}
              category={selectedCard.category}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default RetrievePost;


//Country filtering stuff:

  // // Filter posts by the selected country
  // const countryfilteredPosts = (() => {
  //   if (selectedCountry && selectedCountry.label !== 'All Countries') {
  //     return posts.filter(
  //       (post) => post.location?.country === selectedCountry.label
  //     );
  //   } else if (userLocationCountry) {
  //     return posts.filter(
  //       (post) => post.location?.country === userLocationCountry
  //     );
  //   } else {
  //     return posts; // If no country is selected and no user location, use all posts
  //   }
  // })();

  // // Filter posts by the selected country
  // const countryfilteredPosts = isFeatured ? posts : (() => {
  //   if (selectedCountry && selectedCountry.label !== 'All Countries') {
  //     return posts.filter((post) => post.location?.country === selectedCountry.label);
  //   } else if (userLocationCountry) {
  //     return posts.filter((post) => post.location?.country === userLocationCountry);
  //   } else {
  //     return posts; // If no country is selected and no user location, use all posts
  //   }
  // })();

    // // Determine the displayed posts based on the filtering logic
    // const displayedPost = (() => {
    //   // If there are no filtered posts for the selected country, show all featured posts
    //   if (isFeatured) {
    //     if (countryfilteredFeaturedPosts.length === 0) {
    //       return featuredPosts; // Fallback to all featured posts
    //     }
    //     return countryfilteredFeaturedPosts; // Show filtered featured posts
    //   } else {
    //     // If isFeatured is false, show filtered regular posts
    //     //return countryfilteredPosts; // Show filtered regular posts
    //     return posts
    //   }
    // })();

    // // Assuming userLocation is available from context or props
  // const userLocationCountry = userLocation?.country || null; // Default to 'Ecuador' if no user location is available

  // // Filter featured posts by the selected country
  // const countryfilteredFeaturedPosts = (() => {
  //   if (selectedCountry && selectedCountry.label !== 'All Countries') {
  //     return featuredPosts.filter(
  //       (post) => post.location?.country === selectedCountry.label
  //     );
  //   } else if (userLocationCountry) {
  //     return featuredPosts.filter(
  //       (post) => post.location?.country === userLocationCountry
  //     );
  //   } else {
  //     return featuredPosts; // If no country is selected and no user location, use all featured posts
  //   }
  // })();


//PREVIOUS AD STUFF:
  // const [adsToInterleave, setAdsToInterleave] = useState([]);


// const transformAdsData = (adsData) => {
//   // Step 1: flatten the adsData into a single array
//   const flattenedAds = Object.values(adsData).flat();
//   // Step 2: Sort the flattened array by timestamp (most recent first)
//   const sortedAds = flattenedAds.sort(
//     (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
//   );
//   // Step 3: map the sorted array to the desired structure
//   const transformedAds = sortedAds.map((ad) => ({
//     name: ad.name,
//     title: ad.title,
//     link: ad.externalLinks,
//     // imagePath:ad.images[0],
//     imagePath: ad.images,
//     email: ad.email,
//     phoneNumber: ad.phoneNumber,
//     category: ad.category,
//     location: ad.location,
//     adOptions: ad.adOptions,
//     selectedAdDurations: ad.selectedAdDurations,
//     timestamp: ad.timestamp,
//     readableDate: ad.readableDate,
//     readableTime: ad.readableTime,
//   }));

//   return transformedAds;
// };

  // Transform and filter ads data
  // const adsToDisplay = useMemo(() => transformAdsData(adsData), [adsData]);


  // // Filter posts by the selected country
  // const countryfilteredPosts =
  //   selectedCountry && selectedCountry.label !== 'All Countries'
  //     ? posts.filter((post) => post.location.country === selectedCountry.label)
  //     : posts; // If no country is selected, use all posts

